import _Vue from 'vue';
import i18n from '@/i18n';

export function TranslatePlugin(Vue: typeof _Vue, options?: any): void {
    Vue.prototype.$getTranslation = function(key: string) {
        return i18n.t(key).toString();
    };
}
